import get from 'lodash/get';
import * as personPageActions from '../../action_creators/mcp/person_page_action_creators';
import log from '../../../services/logger_service';

import tagAllFeedActions from '../tag/async_tag_all_feed_actions';
import personActions from './async_person_actions';

import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(personPageActions.personPageLoading({}, store));
    return Promise.all([
      personActions(params, store)(dispatch),
      tagAllFeedActions(params, store, true)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(personPageActions.personPageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(personPageActions.personPageLoadError(err, store));
      });
  };
}
